interface TenantConfig {
    apiUrl: string;
    keycloakLoginUrl: string;
    keycloakLogoutUrl: string;
    keycloakRefreshUrl: string;
    keycloakUserUrl: string;
    /** Path for Keycloak user endpoint. */
    keycloakUserPath: string;
}

/** Leviatano Keycloak endpoints are exposed under /api in all environments. */
const DEFAULT_API_BASE_PATH = "/api";
const LOG_AUTH = process.env.NODE_ENV === "development";

const trimTrailingSlashes = (value: string): string =>
    value.replace(/\/+$/, "");

const joinUrl = (base: string, path: string): string => {
    const normalizedBase = trimTrailingSlashes(base);
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${normalizedBase}${normalizedPath}`;
};

const toPathname = (urlOrPath: string): string => {
    if (urlOrPath.startsWith("http://") || urlOrPath.startsWith("https://")) {
        return new URL(urlOrPath).pathname;
    }
    if (urlOrPath.startsWith("/")) {
        return urlOrPath;
    }
    return `/${urlOrPath}`;
};

const getApiUrl = (): string => {
    if (process.env.NEXT_PUBLIC_API_URL) {
        return trimTrailingSlashes(process.env.NEXT_PUBLIC_API_URL);
    }

    if (typeof window !== "undefined") {
        return `${window.location.origin}${DEFAULT_API_BASE_PATH}`;
    }

    return DEFAULT_API_BASE_PATH;
};

export const getTenantConfig = (): TenantConfig => {
    const apiUrl = getApiUrl();
    const loginUrl = joinUrl(apiUrl, "/login");
    const logoutUrl = joinUrl(apiUrl, "/keycloak/logout");
    const userUrl = joinUrl(apiUrl, "/keycloak/user");
    const refreshUrl = joinUrl(apiUrl, "/keycloak/refresh");
    const userPath = toPathname(userUrl);
    const keycloakLoginUrl =
        process.env.NEXT_PUBLIC_KEYCLOAK_LOGIN_URL || loginUrl;
    const keycloakLogoutUrl =
        process.env.NEXT_PUBLIC_KEYCLOAK_LOGOUT_URL || logoutUrl;

    const config = {
        apiUrl,
        keycloakLoginUrl,
        keycloakLogoutUrl,
        keycloakRefreshUrl: refreshUrl,
        keycloakUserUrl: userUrl,
        keycloakUserPath: userPath,
    };

    if (LOG_AUTH) {
        console.log("[Leviatano getTenantConfig]", {
            NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
            apiUrl: config.apiUrl,
            keycloakLoginUrl: config.keycloakLoginUrl,
            keycloakLogoutUrl: config.keycloakLogoutUrl,
            keycloakRefreshUrl: config.keycloakRefreshUrl,
            keycloakUserUrl: config.keycloakUserUrl,
            keycloakUserPath: config.keycloakUserPath,
        });
    }

    return config;
};
